import { render } from "./LayoutUploadMyAccount.vue?vue&type=template&id=29f6cc72"
import script from "./LayoutUploadMyAccount.vue?vue&type=script&lang=js"
export * from "./LayoutUploadMyAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__